import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import main from "./modules/main";
import signup from "./modules/signup";
import pagePropertiesStore from "./modules/pagePropertiesStore";
import costs from "./modules/costs";
import filterStore from "./modules/filterStore";
import tripStore from "./modules/tripStore";
import contactStore from "./modules/contactStore";
import hourStore from "./modules/hourStore";
import bankStore from "./modules/bankStore";
import dashboard from "./modules/dashboard";
import timeline from "./modules/timeline";
import onboarding from "./modules/onboarding";
import notifications from "./modules/notifications";
import subscriptionStore from "./modules/subscriptionStore";
import balanceSheetStore from "./modules/balanceSheetStore";
import invoices from "./modules/invoices/invoices";
import invoicesLayout from "./modules/invoices/invoices.layout";
import invoicesRecurrent from "./modules/invoices/invoices.recurrent";
import team from "./modules/team";
import brands from "./modules/brands"
import taxreports from "./modules/taxreports";
import modals from "./modules/modals";
import wizard from "./modules/wizard";
import customers from "./modules/customers";
import cacheControl from "./modules/cache/cacheControl";
import accountants from "./modules/accountants/accountants";
import survey from "./modules/survey";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    root: null,
    showPremiumModal: false,
    showCompanyModal: false,
    isPremium: false,
    premiumModalCode: null,
    routePath: ''
  },
  getters: {
    getRoot: state => state.root,
    getPremiumModalState: state => state.showPremiumModal,
    getCompanyModalState: state => state.showCompanyModal,
    getIsPremium: state => state.isPremium,
    getPremiumModalCode: state => state.premiumModalCode,
  },
  mutations: {
    setRoot (state, value) {
      state.root = value
    },
    togglePremiumModal (state, value) {
      state.premiumModalCode = value
      state.showPremiumModal = !state.showPremiumModal
    },
    toggleCompanyModal (state) {
      state.showCompanyModal = !state.showCompanyModal
    },
    setIsPremium (state, value) {
      state.isPremium = value
    },
    setAlert (state, value) {
      state.root.$bvToast.toast(value.text, {
        title: value.title,
        autoHideDelay: value.duration*1000,
        appendToast: true,
        solid: true,
        variant: value.variant,
      })
    },
    SET_PREMIUM_MODAL_CODE (state, value) {
      state.premiumModalCode = value
    },
    SET_ROUTE_PATH(state, path) { state.routePath = path },
  },
  actions: {},
  modules: {
    auth,
    main,
    signup,
    pagePropertiesStore,
    costs,
    subscriptionStore,
    filterStore,
    tripStore,
    contactStore,
    hourStore,
    bankStore,
    balanceSheetStore,
    dashboard,
    notifications,
    timeline,
    onboarding,
    invoices,
    invoicesLayout,
    invoicesRecurrent,
    team,
    brands,
    taxreports,
    modals,
    wizard,
    customers,
    cacheControl,
    accountants,
    survey
  }
})
